import { TextField } from "@mui/material";
import ExternalLinkAnchor from "../../common/ExternalLinkAnchor";

export default function ReadOnlyAdditionalResourceLinkAnchor({
  url,
}: {
  url: string | null;
}) {
  if (!url) {
    return (
      <TextField
        value="-"
        variant="standard"
        id="additional-resource-link"
        label="Additional Resource Link"
        size="small"
        fullWidth
        sx={{
          marginBottom: 2,
        }}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
        }}
      />
    );
  }

  return (
    <ExternalLinkAnchor
      url={url}
      label="additional resource link"
      dataTestid="additional-resource-link-anchor"
    />
  );
}
